var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 43,
    viewBox: "0 0 36 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.84375 0.680292C5.45625 -0.178446 3.7125 -0.206756 2.29688 0.595362C0.88125 1.39748 0 2.90735 0 4.54933V37.7664C0 39.4084 0.88125 40.9183 2.29688 41.7204C3.7125 42.5225 5.45625 42.4848 6.84375 41.6355L33.8438 25.0269C35.1844 24.2059 36 22.7432 36 21.1579C36 19.5725 35.1844 18.1193 33.8438 17.2888L6.84375 0.680292Z",
    fill: "#7C6CC9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/Play.618df873bffd6e985bc3723d8dce4283.svg";
export { ForwardRef as ReactComponent };